import {
  config as kambiConfig,
  links as kambiLinks
} from "../../default/Kambi/Config.resource";

export const links = {
  ...kambiLinks
};

export const config = {
  ...kambiConfig,
  logo_VIP: "sport_logo_VIP"
};
